import styled, { css } from 'styled-components';
import { TextContainer } from 'components/atoms/index';

export const Container = styled.div`
    ${({ theme }) => css`
        max-width: 550px;
        margin-inline: auto;
        padding: 12px 24px 18px 24px;
        border: 1px solid ${theme.colors.primary.primary5};
        border-radius: ${theme.borders.borderRadiusLarge}px;
    `}
`;

export const StyledTextContainer = styled(TextContainer)`
    ${({ theme }) => css`
        height: 300px;
        padding-right: 5px;
        overflow: auto;

        @media (${theme.sizes.mediaQueries.mobileMax}) {
            height: auto;
            padding-right: 0;
        }
    `}
`;
